import { render, staticRenderFns } from "./login-openid.vue?vue&type=template&id=f513fe98"
import script from "./login-openid.vue?vue&type=script&lang=js"
export * from "./login-openid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports